var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// E:/SafeCloud-FrontEnd/WebConsorcioPimentel/node_modules/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = polyfills